import "bootstrap/dist/css/bootstrap.min.css";
import "shared/styles";
import "shared/vendor/App";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
export { render }
import { hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { PageContextProvider } from "shared/hooks/usePageContext.jsx";

// This render() hook only supports SSR, see https://vite-plugin-ssr.com/render-modes for how to modify render() to support SPA
async function render(pageContext) {
  const { Page, pageProps, isHydration } = pageContext
  if (!Page) {
    return
  }
  const page = <PageContextProvider pageContext={pageContext}>
    <BrowserRouter>
      <Page {...pageProps} />
    </BrowserRouter>
  </PageContextProvider>
  const container = document.getElementById('root')

  if (isHydration) {
    hydrateRoot(container, page)
  } else {
    const root = createRoot(container)
    root.render(page)
  }

}

/* To enable Client-side Routing:
export const clientRouting = true
// !! WARNING !! Before doing so, read https://vite-plugin-ssr.com/clientRouting */
